import {Repository} from "./repository";

const resource = "DropDown";
const basicInfoRepo = {
  getList
}
function getList(payLoad) {
  return Repository().get(`${resource}/list?${payLoad}`);
}


export default basicInfoRepo